<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>Guidl - Reset Password</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link href="./styleguide.css" rel="stylesheet" />
    <link href="./globals.css" rel="stylesheet" />
  </head>
  <body>
    <div id="app"></div>
    <router-outlet></router-outlet>
  </body>
</html>
